import type { CountryIso, Language } from "~/types";

export default {
  en: {
    "AFG": "Afghanistan",
    "ALB": "Albania",
    "DZA": "Algeria",
    "ASM": "American Samoa",
    "AND": "Andorra",
    "AGO": "Angola",
    "AIA": "Anguilla",
    "ATG": "Antigua and Barbuda",
    "ARG": "Argentina",
    "ARM": "Armenia",
    "ABW": "Aruba",
    "AUS": "Australia",
    "AUT": "Austria",
    "AZE": "Azerbaijan",
    "BHR": "Bahrain",
    "BGD": "Bangladesh",
    "BRB": "Barbados",
    "BLR": "Belarus",
    "BEL": "Belgium",
    "BLZ": "Belize",
    "BEN": "Benin",
    "BMU": "Bermuda",
    "BTN": "Bhutan",
    "BIH": "Bosnia and Herzegovina",
    "BWA": "Botswana",
    "BVT": "Bouvet Island",
    "BRA": "Brazil",
    "VGB": "British Virgin Islands",
    "BGR": "Bulgaria",
    "BFA": "Burkina Faso",
    "BDI": "Burundi",
    "KHM": "Cambodia",
    "CMR": "Cameroon",
    "CAN": "Canada",
    "CPV": "Cape Verde",
    "TCD": "Chad",
    "CHL": "Chile",
    "CHN": "China",
    "CXR": "Christmas Island",
    "CIV": "Ivory Coast",
    "CZE": "Czech Republic",
    "COL": "Colombia",
    "CRI": "Costa Rica",
    "HRV": "Croatia",
    "CUB": "Cuba",
    "CUW": "Curaçao",
    "CYP": "Cyprus",
    "DNK": "Denmark",
    "DJI": "Djibouti",
    "DMA": "Dominica",
    "ECU": "Ecuador",
    "EGY": "Egypt",
    "SLV": "El Salvador",
    "GNQ": "Equatorial Guinea",
    "ERI": "Eritrea",
    "EST": "Estonia",
    "SWZ": "Eswatini",
    "ETH": "Ethiopia",
    "FJI": "Fiji",
    "FIN": "Finland",
    "FRA": "France",
    "GUF": "French Guiana",
    "PYF": "French Polynesia",
    "GAB": "Gabon",
    "GEO": "Georgia",
    "DEU": "Germany",
    "GHA": "Ghana",
    "GIB": "Gibraltar",
    "GRC": "Greece",
    "GRL": "Greenland",
    "GRD": "Grenada",
    "GLP": "Guadeloupe",
    "GUM": "Guam",
    "GTM": "Guatemala",
    "GGY": "Guernsey",
    "GIN": "Guinea",
    "GNB": "Guinea-Bissau",
    "GUY": "Guyana",
    "HTI": "Haiti",
    "HND": "Honduras",
    "HKG": "Hong Kong",
    "HUN": "Hungary",
    "ISL": "Iceland",
    "IND": "India",
    "IDN": "Indonesia",
    "IRQ": "Iraq",
    "IRL": "Ireland",
    "ISR": "Israel",
    "IMN": "Isle of Man",
    "ITA": "Italy",
    "JAM": "Jamaica",
    "JPN": "Japan",
    "JEY": "Jersey",
    "JOR": "Jordan",
    "KAZ": "Kazakhstan",
    "KEN": "Kenya",
    "KIR": "Kiribati",
    "KWT": "Kuwait",
    "KGZ": "Kyrgyzstan",
    "LVA": "Latvia",
    "LBN": "Lebanon",
    "LSO": "Lesotho",
    "LBR": "Liberia",
    "LBY": "Libya",
    "LIE": "Liechtenstein",
    "LTU": "Lithuania",
    "LUX": "Luxembourg",
    "MDG": "Madagascar",
    "MWI": "Malawi",
    "MYS": "Malaysia",
    "MDV": "Maldives",
    "MLI": "Mali",
    "MLT": "Malta",
    "MTQ": "Martinique",
    "MRT": "Mauritania",
    "MUS": "Mauritius",
    "MYT": "Mayotte",
    "MEX": "Mexico",
    "MCO": "Monaco",
    "MNG": "Mongolia",
    "MNE": "Montenegro",
    "MSR": "Montserrat",
    "MAR": "Morocco",
    "MOZ": "Mozambique",
    "MMR": "Myanmar",
    "NAM": "Namibia",
    "NRU": "Nauru",
    "NPL": "Nepal",
    "NCL": "New Caledonia",
    "NZL": "New Zealand",
    "NIC": "Nicaragua",
    "NGA": "Nigeria",
    "NIU": "Niue",
    "NFK": "Norfolk Island",
    "NOR": "Norway",
    "OMN": "Oman",
    "PAK": "Pakistan",
    "PLW": "Palau",
    "PAN": "Panama",
    "PNG": "Papua New Guinea",
    "PRY": "Paraguay",
    "PER": "Peru",
    "POL": "Poland",
    "PRT": "Portugal",
    "PRI": "Puerto Rico",
    "QAT": "Qatar",
    "ROU": "Romania",
    "RWA": "Rwanda",
    "BLM": "Saint Barthélemy",
    "KNA": "Saint Kitts and Nevis",
    "LCA": "Saint Lucia",
    "SPM": "Saint Pierre and Miquelon",
    "VCT": "Saint Vincent and the Grenadines",
    "WSM": "Samoa",
    "SMR": "San Marino",
    "SAU": "Saudi Arabia",
    "SEN": "Senegal",
    "SRB": "Serbia",
    "SYC": "Seychelles",
    "SLE": "Sierra Leone",
    "SGP": "Singapore",
    "SVK": "Slovakia",
    "SVN": "Slovenia",
    "SLB": "Solomon Islands",
    "SOM": "Somalia",
    "SUN": "USSR",
    "ZAF": "South Africa",
    "SSD": "South Sudan",
    "ESP": "Spain",
    "LKA": "Sri Lanka",
    "SUR": "Suriname",
    "SWE": "Sweden",
    "CHE": "Switzerland",
    "TJK": "Tajikistan",
    "THA": "Thailand",
    "TLS": "Timor-Leste",
    "TGO": "Togo",
    "TON": "Tonga",
    "TTO": "Trinidad and Tobago",
    "TUN": "Tunisia",
    "TUR": "Turkey",
    "TKM": "Turkmenistan",
    "TUV": "Tuvalu",
    "UGA": "Uganda",
    "UKR": "Ukraine",
    "UZB": "Uzbekistan",
    "WLF": "Wallis and Futuna",
    "ESH": "Western Sahara",
    "YEM": "Yemen",
    "ZMB": "Zambia",
    "ZWE": "Zimbabwe",
    "ALA": "Åland",
    "BHS": "Bahamas",
    "BOL": "Bolivia",
    "BES": "Bonaire",
    "BRN": "Brunei",
    "CYM": "Cayman Islands",
    "CAF": "Central African Republic",
    "CCK": "Cocos (Keeling) Islands",
    "COM": "Comoros",
    "COD": "Congo",
    "COK": "Cook Islands",
    "DOM": "Dominican Republic",
    "FLK": "Falkland Islands",
    "FRO": "Faroe Islands",
    "VAT": "Holy See",
    "IRN": "Iran",
    "PRK": "Korea",
    "XKX": "Kosovo",
    "MHL": "Marshall Islands",
    "MDA": "Moldova",
    "NLD": "Netherlands",
    "NER": "Niger",
    "MKD": "North Macedonia",
    "GBR": "United Kingdom",
    "MNP": "Northern Mariana Islands",
    "PHL": "Philippines",
    "RUS": "Russia",
    "SHN": "Saint Helena",
    "MAF": "Saint Martin",
    "SYR": "Syria",
    "TZA": "Tanzania",
    "ARE": "United Arab Emirates",
    "LAO": "Laos",
    "MAC": "Macau",
    "FSM": "Micronesia, Federated States of",
    "PCN": "Pitcairn Islands",
    "COG": "Republic of the Congo",
    "REU": "Reunion",
    "STP": "São Tomé and Príncipe",
    "GMB": "The Gambia",
    "TKL": "Tokelau Islands",
    "TWN": "Taiwan (officially Republic of China)",
    "KOR": "South Korea",
    "USA": "United States",
    "VEN": "Venezuela",
    "VIR": "United States Virgin Islands",
    "VNM": "Vietnam",
    "PSE": "Palestine",
    "SXM": "Sint Maarten",
    "SDN": "South Sudan",
    "TCA": "Turks and Caicos Islands",
    "URY": "Uruguay",
    "VUT": "Vanuatu",
    "SCH": "Schengen Area"
  },
  ru: {
    "AFG": "Афганистан",
    "ALB": "Албания",
    "DZA": "Алжир",
    "ASM": "Американское Самоа",
    "AND": "Андорра",
    "AGO": "Ангола",
    "AIA": "Ангилья",
    "ATG": "Антигуа и Барбуда",
    "ARG": "Аргентина",
    "ARM": "Армения",
    "ABW": "Аруба",
    "AUS": "Австралия",
    "AUT": "Австрия",
    "AZE": "Азербайджан",
    "BHR": "Бахрейн",
    "BGD": "Бангладеш",
    "BRB": "Барбадос",
    "BLR": "Беларусь",
    "BEL": "Бельгия",
    "BLZ": "Белиз",
    "BEN": "Бенин",
    "BMU": "Бермуды",
    "BTN": "Бутан",
    "BIH": "Босния и Герцеговина",
    "BWA": "Ботсвана",
    "BVT": "Остров Буве",
    "BRA": "Бразилия",
    "VGB": "Виргинские Острова (Великобритания)",
    "BGR": "Болгария",
    "BFA": "Буркина-Фасо",
    "BDI": "Бурунди",
    "KHM": "Камбоджа",
    "CMR": "Камерун",
    "CAN": "Канада",
    "CPV": "Кабо-Верде",
    "TCD": "Чад",
    "CHL": "Чили",
    "CHN": "Китай (Китайская Народная Республика)",
    "CXR": "Остров Рождества",
    "CIV": "Кот-д’Ивуар",
    "CZE": "Чехия",
    "COL": "Колумбия",
    "CRI": "Коста-Рика",
    "HRV": "Хорватия",
    "CUB": "Куба",
    "CUW": "Кюрасао",
    "CYP": "Кипр",
    "DNK": "Дания",
    "DJI": "Джибути",
    "DMA": "Доминика",
    "ECU": "Эквадор",
    "EGY": "Египет",
    "SLV": "Сальвадор",
    "GNQ": "Экваториальная Гвинея",
    "ERI": "Эритрея",
    "EST": "Эстония",
    "SWZ": "Эсватини",
    "ETH": "Эфиопия",
    "FJI": "Фиджи",
    "FIN": "Финляндия",
    "FRA": "Франция",
    "GUF": "Гвиана",
    "PYF": "Французская Полинезия",
    "GAB": "Габон",
    "GEO": "Грузия",
    "DEU": "Германия",
    "GHA": "Гана",
    "GIB": "Гибралтар",
    "GRC": "Греция",
    "GRL": "Гренландия",
    "GRD": "Гренада",
    "GLP": "Гваделупа",
    "GUM": "Гуам",
    "GTM": "Гватемала",
    "GGY": "Гернси",
    "GIN": "Гвинея",
    "GNB": "Гвинея-Бисау",
    "GUY": "Гайана",
    "HTI": "Гаити",
    "HND": "Гондурас",
    "HKG": "Гонконг",
    "HUN": "Венгрия",
    "ISL": "Исландия",
    "IND": "Индия",
    "IDN": "Индонезия",
    "IRQ": "Ирак",
    "IRL": "Ирландия",
    "ISR": "Израиль",
    "IMN": "Остров Мэн",
    "ITA": "Италия",
    "JAM": "Ямайка",
    "JPN": "Япония",
    "JEY": "Джерси",
    "JOR": "Иордания",
    "KAZ": "Казахстан",
    "KEN": "Кения",
    "KIR": "Кирибати",
    "KWT": "Кувейт",
    "KGZ": "Киргизия",
    "LVA": "Латвия",
    "LBN": "Ливан",
    "LSO": "Лесото",
    "LBR": "Либерия",
    "LBY": "Ливия",
    "LIE": "Лихтенштейн",
    "LTU": "Литва",
    "LUX": "Люксембург",
    "MDG": "Мадагаскар",
    "MWI": "Малави",
    "MYS": "Малайзия",
    "MDV": "Мальдивы",
    "MLI": "Мали",
    "MLT": "Мальта",
    "MTQ": "Мартиника",
    "MRT": "Мавритания",
    "MUS": "Маврикий",
    "MYT": "Майотта",
    "MEX": "Мексика",
    "MCO": "Монако",
    "MNG": "Монголия",
    "MNE": "Черногория",
    "MSR": "Монтсеррат",
    "MAR": "Марокко",
    "MOZ": "Мозамбик",
    "MMR": "Мьянма",
    "NAM": "Намибия",
    "NRU": "Науру",
    "NPL": "Непал",
    "NCL": "Новая Каледония",
    "NZL": "Новая Зеландия",
    "NIC": "Никарагуа",
    "NGA": "Нигерия",
    "NIU": "Ниуэ",
    "NFK": "Остров Норфолк",
    "NOR": "Норвегия",
    "OMN": "Оман",
    "PAK": "Пакистан",
    "PLW": "Палау",
    "PAN": "Панама",
    "PNG": "Папуа — Новая Гвинея",
    "PRY": "Парагвай",
    "PER": "Перу",
    "POL": "Польша",
    "PRT": "Португалия",
    "PRI": "Пуэрто-Рико",
    "QAT": "Катар",
    "ROU": "Румыния",
    "RWA": "Руанда",
    "BLM": "Сен-Бартелеми",
    "KNA": "Сент-Китс и Невис",
    "LCA": "Сент-Люсия",
    "SPM": "Сен-Пьер и Микелон",
    "VCT": "Сент-Винсент и Гренадины",
    "WSM": "Самоа",
    "SMR": "Сан-Марино",
    "SAU": "Саудовская Аравия",
    "SEN": "Сенегал",
    "SRB": "Сербия",
    "SYC": "Сейшельские Острова",
    "SLE": "Сьерра-Леоне",
    "SGP": "Сингапур",
    "SVK": "Словакия",
    "SVN": "Словения",
    "SLB": "Соломоновы Острова",
    "SOM": "Сомали",
    "SUN": "СССР",
    "ZAF": "ЮАР",
    "SSD": "Южный Судан",
    "ESP": "Испания",
    "LKA": "Шри-Ланка",
    "SUR": "Суринам",
    "SWE": "Швеция",
    "CHE": "Швейцария",
    "TJK": "Таджикистан",
    "THA": "Таиланд",
    "TLS": "Восточный Тимор",
    "TGO": "Того",
    "TON": "Тонга",
    "TTO": "Тринидад и Тобаго",
    "TUN": "Тунис",
    "TUR": "Турция",
    "TKM": "Туркменистан",
    "TUV": "Тувалу",
    "UGA": "Уганда",
    "UKR": "Украина",
    "UZB": "Узбекистан",
    "WLF": "Уоллис и Футуна",
    "ESH": "САДР",
    "YEM": "Йемен",
    "ZMB": "Замбия",
    "ZWE": "Зимбабве",
    "ALA": "Аландские острова",
    "BHS": "Багамские Острова",
    "BOL": "Боливия",
    "BES": "Бонайре, Синт-Эстатиус и Саба",
    "BRN": "Бруней",
    "CYM": "Острова Кайман",
    "CAF": "ЦАР",
    "CCK": "Кокосовые острова",
    "COM": "Коморы",
    "COD": "ДР Конго",
    "COK": "Острова Кука",
    "DOM": "Доминиканская Республика",
    "FLK": "Фолклендские острова",
    "FRO": "Фарерские острова",
    "VAT": "Ватикан",
    "IRN": "Иран",
    "PRK": "КНДР (Корейская Народно-Демократическая Республика)",
    "MHL": "Маршалловы Острова",
    "MDA": "Молдавия",
    "NLD": "Нидерланды",
    "NER": "Нигер",
    "MKD": "Северная Македония",
    "GBR": "Великобритания",
    "MNP": "Северные Марианские Острова",
    "PHL": "Филиппины",
    "RUS": "Россия",
    "SHN": "Остров Святой Елены",
    "MAF": "Сен-Мартен",
    "SYR": "Сирия",
    "TZA": "Танзания",
    "ARE": "ОАЭ",
    "LAO": "Лаос",
    "MAC": "Макао",
    "FSM": "Микронезия",
    "PCN": "Острова Питкэрн",
    "COG": "Республика Конго",
    "REU": "Реюньон",
    "STP": "Сан-Томе и Принсипи",
    "GMB": "Гамбия",
    "TKL": "Токелау",
    "TWN": "Китайская Республика",
    "KOR": "Южная Корея",
    "XKX": "Косово",
    "USA": "США",
    "VEN": "Венесуэла",
    "VIR": "Виргинские Острова (США)",
    "VNM": "Вьетнам",
    "PSE": "Палестина",
    "SXM": "Синт-Мартен",
    "SDN": "Судан",
    "TCA": "Острова Теркс и Кайкос",
    "URY": "Уругвай",
    "VUT": "Вануату",
    "SCH": "Шенгенская зона"
  },
  sv: {
    "ABW": "Aruba",
    "AFG": "Afghanistan",
    "AGO": "Angola",
    "AIA": "Anguilla",
    "ALA": "Åland",
    "ALB": "Albanien",
    "AND": "Andorra",
    "ARE": "Förenade Arabemiraten",
    "ARG": "Argentina",
    "ARM": "Armenien",
    "ASM": "Amerikanska Samoa",
    "ATG": "Antigua och Barbuda",
    "AUS": "Australien",
    "AUT": "Österrike",
    "AZE": "Azerbajdzjan",
    "BDI": "Burundi",
    "BEL": "Belgien",
    "BEN": "Benin",
    "BES": "Bonaire",
    "BFA": "Burkina Faso",
    "BGD": "Bangladesh",
    "BGR": "Bulgarien",
    "BHR": "Bahrain",
    "BHS": "Bahamas",
    "BIH": "Bosnien och Hercegovina",
    "BLM": "Saint Barthélemy",
    "BLR": "Vitryssland",
    "BLZ": "Belize",
    "BMU": "Bermudas",
    "BOL": "Bolivia",
    "BRA": "Brasilien",
    "BRB": "Barbados",
    "BRN": "Brunei",
    "BTN": "Bhutan",
    "BVT": "Bouvetön",
    "BWA": "Botswana",
    "CAF": "Centralafrikanska republiken",
    "CAN": "Kanada",
    "CCK": "Kokosöarna (Keelingöarna)",
    "XKX": "Kosovo",
    "CHE": "Schweiz",
    "CHL": "Chile",
    "CHN": "Kina",
    "CIV": "Elfenbenskusten",
    "CMR": "Kamerun",
    "COD": "Kongo",
    "COG": "Republiken Kongo",
    "COK": "Cooköarna",
    "COL": "Colombia",
    "COM": "Komorerna",
    "CPV": "Kap Verde",
    "CRI": "Costa Rica",
    "CUB": "Kuba",
    "CUW": "Curaçao",
    "CXR": "Julön",
    "CYM": "Caymanöarna",
    "CYP": "Cypern",
    "CZE": "Tjeckien",
    "DEU": "Tyskland",
    "DJI": "Djibouti",
    "DMA": "Dominica",
    "DNK": "Danmark",
    "DOM": "Dominikanska republiken",
    "DZA": "Algeriet",
    "ECU": "Ecuador",
    "EGY": "Egypten",
    "ERI": "Eritrea",
    "ESH": "Västsahara",
    "ESP": "Spanien",
    "EST": "Estland",
    "ETH": "Etiopien",
    "FIN": "Finland",
    "FJI": "Fijiöarna",
    "FLK": "Falklandsöarna",
    "FRA": "Frankrike",
    "FRO": "Färöarna",
    "FSM": "Mikronesiens federerade stater",
    "GAB": "Gabon",
    "GBR": "Storbritannien",
    "GEO": "Georgien",
    "GGY": "Guernsey",
    "GHA": "Ghana",
    "GIB": "Gibraltar",
    "GIN": "Guinea",
    "GLP": "Guadaloupe",
    "GMB": "Gambia",
    "GNB": "Guinea-Bissau",
    "GNQ": "Ekvatorialguinea",
    "GRC": "Grekland",
    "GRD": "Grenada",
    "GRL": "Grönland",
    "GTM": "Guatemala",
    "GUF": "Franska Guyana",
    "GUM": "Guam",
    "GUY": "Guyana",
    "HKG": "Hongkong",
    "HND": "Honduras",
    "HRV": "Kroatien",
    "HTI": "Haiti",
    "HUN": "Ungern",
    "IDN": "Indonesien",
    "IMN": "Isle of Man",
    "IND": "Indien",
    "IRL": "Irland",
    "IRN": "Iran",
    "IRQ": "Irak",
    "ISL": "Island",
    "ISR": "Israel",
    "ITA": "Italien",
    "JAM": "Jamaica",
    "JEY": "Jersey",
    "JOR": "Jordanien",
    "JPN": "Japan",
    "KAZ": "Kazakstan",
    "KEN": "Kenya",
    "KGZ": "Kirgizistan",
    "KHM": "Kambodja",
    "KIR": "Kiribati",
    "KNA": "Saint Kitts och Nevis",
    "KOR": "Sydkorea",
    "KWT": "Kuwait",
    "LAO": "Laos",
    "LBN": "Libanon",
    "LBR": "Liberia",
    "LBY": "Libyen",
    "LCA": "Saint Lucia",
    "LIE": "Liechtenstein",
    "LKA": "Sri Lanka",
    "LSO": "Lesotho",
    "LTU": "Litauen",
    "LUX": "Luxemburg",
    "LVA": "Lettland",
    "MAC": "Macao",
    "MAF": "Saint-Martin",
    "MAR": "Marocko",
    "MCO": "Monaco",
    "MDA": "Moldavien",
    "MDG": "Madagaskar",
    "MDV": "Maldiverna",
    "MEX": "Mexiko",
    "MHL": "Marshallöarna",
    "MKD": "Nordmakedonien",
    "MLI": "Mali",
    "MLT": "Malta",
    "MMR": "Myanmar",
    "MNE": "Montenegro",
    "MNG": "Mongoliet",
    "MNP": "Nordmarianerna",
    "MOZ": "Moçambique",
    "MRT": "Mauretanien",
    "MSR": "Montserrat",
    "MTQ": "Martinique",
    "MUS": "Mauritius",
    "MWI": "Malawi",
    "MYS": "Malaysia",
    "MYT": "Mayotte",
    "NAM": "Namibia",
    "NCL": "Nya Kaledonien",
    "NER": "Niger",
    "NFK": "Norfolkön",
    "NGA": "Nigeria",
    "NIC": "Nicaragua",
    "NIU": "Niue",
    "NLD": "Nederländerna",
    "NOR": "Norge",
    "NPL": "Nepal",
    "NRU": "Nauru",
    "NZL": "Nya Zeeland",
    "OMN": "Oman",
    "PAK": "Pakistan",
    "PAN": "Panama",
    "PCN": "Pitcairnöarna",
    "PER": "Peru",
    "PHL": "Filippinerna",
    "PLW": "Palau",
    "PNG": "Papua Nya Guinea",
    "POL": "Polen",
    "PRI": "Puerto Rico",
    "PRK": "Korea",
    "PRT": "Portugal",
    "PRY": "paraguay",
    "PYF": "Franska Polynesien",
    "QAT": "Qatar",
    "REU": "Réunion",
    "ROU": "Rumänien",
    "RUS": "Ryssland",
    "RWA": "Rwanda",
    "SAU": "Saudiarabien",
    "SEN": "Senegal",
    "SGP": "Singapore",
    "SHN": "Sankta Helena",
    "SLB": "Salomonöarna",
    "SLE": "Sierra Leone",
    "SLV": "El Salvador",
    "SMR": "San Marino",
    "SOM": "Somalia",
    "SPM": "Saint Pierre och Miquelon",
    "SRB": "Serbien",
    "SSD": "Sydsudan",
    "STP": "São Tomé och Príncipe",
    "SUR": "Surinam",
    "SVK": "Slovakien",
    "SVN": "Slovenien",
    "SWE": "Sverige",
    "SWZ": "Eswatini",
    "SYC": "Seychellerna",
    "SYR": "Syrien",
    "SUN": "Sovjetunionen",
    "TCD": "Chad",
    "TGO": "Togo",
    "THA": "Thailand",
    "TJK": "Tadzjikistan",
    "TKL": "Tokelauöarna",
    "TKM": "Turkmenistan",
    "TLS": "Östtimor",
    "TON": "Tonga",
    "TTO": "Trinidad och Tobago",
    "TUN": "Tunisien",
    "TUR": "Turkiet",
    "TUV": "Tuvalu",
    "TWN": "Taiwan",
    "TZA": "Tanzania",
    "UGA": "Uganda",
    "UKR": "Ukraina",
    "USA": "USA",
    "UZB": "Uzbekistan",
    "VAT": "Holy See",
    "VCT": "Saint Vincent och Grenadinerna",
    "VEN": "Venezuela",
    "VGB": "Brittiska Jungfruöarna",
    "VIR": "Amerikanska Jungfruöarna",
    "VNM": "Vietnam",
    "WLF": "Wallis- och Futunaöarna",
    "WSM": "Samoa",
    "YEM": "Jemen",
    "ZAF": "Sydafrika",
    "ZMB": "Zambia",
    "ZWE": "Zimbabwe",
    "PSE": "Palestinska territorierna",
    "SXM": "Sint Maarten",
    "SDN": "Sudan",
    "TCA": "Turks- och Caicosöarna",
    "URY": "Uruguay",
    "VUT": "Vanuatu",
    "SCH": "Schengenområdet"
  },
  he: {
    "ABW": "ארובה",
    "AFG": "אפגניסטן",
    "AGO": "אנגולה",
    "AIA": "אנגווילה",
    "ALA": "איי אולנד",
    "ALB": "אלבניה",
    "AND": "אנדורה",
    "ARE": "איחוד האמירויות הערביות",
    "ARG": "ארגנטינה",
    "ARM": "ארמניה",
    "ASM": "סמואה האמריקנית",
    "ATG": "אנטיגואה וברבודה",
    "AUS": "אוסטרליה",
    "AUT": "אוסטריה",
    "AZE": "אזרבייג'ן",
    "BDI": "בורונדי",
    "BEL": "בלגיה",
    "BEN": "בנין",
    "BES": "בונייר",
    "BFA": "בורקינה פאסו",
    "BGD": "בנגלדש",
    "BGR": "בולגריה",
    "BHR": "בחריין",
    "BHS": "בהאמה",
    "BIH": "בוסניה הרצוגובינה",
    "BLM": "סן ברתלמי",
    "BLR": "בלארוס",
    "BLZ": "בליז",
    "BMU": "ברמודה",
    "BOL": "בוליביה",
    "BRA": "ברזיל",
    "BRB": "ברבדוס",
    "BRN": "ברוניי",
    "BTN": "בוטאן",
    "BVT": "איי בובה",
    "BWA": "בוצוואנה",
    "CAF": "הרפובליקה המרכז אפריקאית",
    "CAN": "קנדה",
    "CCK": "איי קוקוס",
    "CHE": "שווייץ",
    "CHL": "צ׳ילה",
    "CHN": "סין",
    "CIV": "חוף השנהב",
    "CMR": "קמרון",
    "COD": "קונגו",
    "COG": "הרפובליקה של קונגו",
    "COK": "איי קוק",
    "COL": "קולומביה",
    "COM": "קומורו",
    "CPV": "כף ורדה",
    "CRI": "קוסטה ריקה",
    "CUB": "קובה",
    "CUW": "קוראסאו",
    "CXR": "אי חג המולד",
    "CYM": "איי קיימן",
    "CYP": "קפריסין",
    "CZE": "צ'כיה",
    "DEU": "גרמניה",
    "DJI": "ג'יבוטי",
    "DMA": "דומיניקה",
    "DNK": "דנמרק",
    "DOM": "הרפובליקה הדומיניקנית",
    "DZA": "אלג׳יריה",
    "ECU": "אקודור",
    "EGY": "מצרים",
    "ERI": "אריתריאה",
    "ESH": "סהרה המערבית",
    "ESP": "ספרד",
    "EST": "אסטוניה",
    "ETH": "אתיופיה",
    "FIN": "פינלנד",
    "FJI": "פיג'י",
    "FLK": "איי פוקלנד",
    "FRA": "צרפת",
    "FRO": "איי פארו",
    "FSM": "מיקרונזיה",
    "GAB": "גאבון",
    "GBR": "בריטניה",
    "GEO": "גאורגיה",
    "GGY": "גרנסי",
    "GHA": "גאנה",
    "GIB": "גיברלטר",
    "GIN": "גיניאה",
    "GLP": "גואדלופ",
    "GMB": "גמביה",
    "GNB": "גיניאה ביסאו",
    "GNQ": "גינאה המשוונית",
    "GRC": "יוון",
    "GRD": "גרנדה",
    "GRL": "גרינלנד",
    "GTM": "גואטמלה",
    "GUF": "גיאנה הצרפתית",
    "GUM": "גואם",
    "GUY": "גיאנה",
    "HKG": "הונג-קונג",
    "HND": "הונדורס",
    "HRV": "קרואטיה",
    "HTI": "האיטי",
    "HUN": "הונגריה",
    "IDN": "אינדונזיה",
    "IMN": "האי מאן",
    "IND": "הודו",
    "IRL": "אירלנד",
    "IRN": "אירן",
    "IRQ": "עיראק",
    "ISL": "איסלנד",
    "ISR": "ישראל",
    "ITA": "איטליה",
    "JAM": "ג'אמייקה",
    "JEY": "ג׳רסי",
    "JOR": "ירדן",
    "JPN": "יפן",
    "KAZ": "קזחסטן",
    "KEN": "קניה",
    "KGZ": "קירגיזסטן",
    "KHM": "קמבודיה",
    "KIR": "קיריבטי",
    "KNA": "סנט קיטס ונוויס",
    "KOR": "דרום קוריאה",
    "XKX": "קוסובו",
    "KWT": "כווית",
    "LAO": "לאוס",
    "LBN": "לבנון",
    "LBR": "ליבריה",
    "LBY": "לוב",
    "LCA": "סנט לוסיה",
    "LIE": "ליכטנשטיין",
    "LKA": "סרי לנקה",
    "LSO": "לסוטו",
    "LTU": "ליטא,ליטה",
    "LUX": "לוקסמבורג",
    "LVA": "לטביה",
    "MAC": "מקאו",
    "MAF": "סן מרטן",
    "MAR": "מרוקו",
    "MCO": "מונאקו",
    "MDA": "מולדובה",
    "MDG": "מדגסקר",
    "MDV": "האיים המלדיבים",
    "MEX": "מקסיקו",
    "MHL": "איי מרשל",
    "MKD": "מקדוֹניה הצפונית",
    "MLI": "מאלי",
    "MLT": "מלטה",
    "MMR": "מיאנמר",
    "MNE": "מונטנגרו",
    "MNG": "מונגוליה",
    "MNP": "איי מריאנה הצפוניים",
    "MOZ": "מוזמביק",
    "MRT": "מאוריטניה",
    "MSR": "מונטסרט",
    "MTQ": "מרטיניק",
    "MUS": "מאוריציוס",
    "MWI": "מלאווי",
    "MYS": "מלזיה",
    "MYT": "מיוט",
    "NAM": "נמיביה",
    "NCL": "קלדוניה החדשה",
    "NER": "ניז'ר",
    "NFK": "איי נורפולק",
    "NGA": "ניגריה",
    "NIC": "ניקראגווה",
    "NIU": "ניואה",
    "NLD": "ארצות השפלה",
    "NOR": "נורבגיה",
    "NPL": "נפאל",
    "NRU": "נאורו",
    "NZL": "ניו-זילנד",
    "OMN": "עומן",
    "PAK": "פקיסטן",
    "PAN": "פנמה",
    "PCN": "איי פיטקרן",
    "PER": "פרו",
    "PHL": "פיליפינים",
    "PLW": "פלאו",
    "PNG": "פפואה גינאה החדשה",
    "POL": "פולין",
    "PRI": "פוארטו ריקו",
    "PRK": "קוריאה",
    "PRT": "פורטוגל",
    "PRY": "פאראגוואי",
    "PYF": "פולינזיה הצרפתית",
    "QAT": "קטאר",
    "REU": "ראוניון",
    "ROU": "רומניה",
    "RUS": "רוסיה",
    "RWA": "רואנדה",
    "SAU": "ערב הסעודית",
    "SEN": "סנגל",
    "SGP": "סינגפור",
    "SHN": "סנט הלנה",
    "SLB": "איי שלמה",
    "SLE": "סיירה לאונה",
    "SLV": "אל סלבדור",
    "SMR": "סן מרינו",
    "SOM": "סומליה",
    "SPM": "סן פייר ומיקלון",
    "SRB": "סרביה",
    "SSD": "סודאן",
    "STP": "סאו טומה ופרינסיפה",
    "SUR": "סורינאם",
    "SVK": "סלובקיה",
    "SVN": "סלובניה",
    "SWE": "שבדיה",
    "SWZ": "אסוואטיני",
    "SYC": "סיישל",
    "SYR": "סיריע",
    "SUN": "ברית המועצות",
    "TCD": "צ׳אד",
    "TGO": "טוגו",
    "THA": "תאילנד",
    "TJK": "טאג'יקיסטן",
    "TKL": "טוקלאו",
    "TKM": "טורקמניסטן",
    "TLS": "מזרח טימור",
    "TON": "טונגה",
    "TTO": "טרינידד וטובגו",
    "TUN": "טוניסיה or תוניסיה",
    "TUR": "תורכיה or טורקיה",
    "TUV": "טובאלו",
    "TWN": "טאיוואן",
    "TZA": "טנזניה",
    "UGA": "אוגנדה",
    "UKR": "אוקראינה",
    "USA": "ארצות הברית",
    "UZB": "אוזבקיסטן",
    "VAT": "הכס הקדוש",
    "VCT": "סנט וינסנט והגרנדינים",
    "VGB": "איי הבתולה הבריטיים",
    "VEN": "ונצואלה",
    "VIR": "איי הבתולה של ארצות הברית",
    "VNM": "ויאטנאם",
    "WLF": "ווליס ופוטונה",
    "WSM": "סמואה",
    "YEM": "תימן",
    "ZAF": "דרום אפריקה",
    "ZMB": "זמביה",
    "ZWE": "זימבבואה",
    "PSE": "השטחים הפלסטיניים",
    "SXM": "סנט מארטן",
    "SDN": "סודן",
    "TCA": "איי טורקס וקאיקוס",
    "URY": "אורוגוואי",
    "VUT": "ונואטו",
    "SCH": "אזור שנגן"
  }
} satisfies Record<Language, Record<CountryIso, string>>;